<template>
  <div>
    <div class="container dashboard">
      <menuAdmin />

      <Modal v-if="addOfferModal" :closeModal="toggleModal">
        <h4 class="text-center">Agregar nueva oferta</h4>
        <form v-on:submit.prevent="onSubmit">
          <div class="row">
            <div class="col-12">
              <div class="form-group">
                <label for=""><strong>Titulo</strong></label>
                <input type="text" class="form-control" placeholder="Titulo" v-model="nombre" required />
              </div>
              <div class="form-group">
                <label for=""><strong>Link Oferta</strong></label>
                <input type="url" class="form-control" placeholder="Url" v-model="url" />
              </div>
              <div class="form-group">
                <label for=""><strong>Orden</strong></label>
                <input type="number" class="form-control" placeholder="Orden" v-model="orden" required />
              </div>
              <label for=""><strong>Imagen</strong></label>
              <div class="custom-file">
                <input type="file" accept="image/*" id="archivo" class="custom-file-input" required />
                <label class="custom-file-label" for="validatedCustomFile">Seleccionar archivo...</label>
              </div>
            </div>
            <div class="col-md-12 d-flex justify-content-center mt-3">
              <button type="submit" class="primary-btn" :disabled="loading">
                <i class="fa fa-upload mr-2" aria-hidden="true"></i>Agregar
              </button>
            </div>
          </div>
        </form>
      </Modal>

      <div class="d-flex align-item-center justify-content-between mb-4">
        <h4 class="mb-0 align-content-center">Ofertas publicadas</h4>
        <button class="primary-btn" @click="toggleModal()"><i class="fa fa-upload mr-2"
            aria-hidden="true"></i>Agregar</button>
      </div>
      <div class="row">
        <div class="col-md-6" v-for="item in productos" v-bind:key="item.id">
          <button type="button" class="btn btn-danger" @click="elimina(item.id)">
            <i class="fa fa-trash-o" aria-hidden="true"></i>
          </button>
          <table class="table border rounded">
            <tr>
              <td>
                <div class="position-relative">
                  <div
                    class="position-absolute text-center h-100 d-flex w-100 align-items-center justify-content-center"
                    @click="chooseFiles(`${item.id}_foto`)" style="cursor:pointer;">
                    <div class="p-3 bg-primary rounded-circle" style="opacity: 0.6">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16">
                        <path fill="none" d="M0 0H24V24H0z" />
                        <path
                          d="M11 20L1 12l10-8v5c5.523 0 10 4.477 10 10 0 .273-.01.543-.032.81C19.46 16.95 16.458 15 13 15h-2v5z"
                          fill="rgba(255,255,255,1)" />
                      </svg>
                    </div>
                  </div>
                  <img :src="item.imagen" class="img-fluid" />
                </div>
                <div class="d-flex mt-3">
                  <input type="file" accept="image/*" class="d-none" :id="`${item.id}_foto`"
                    @change="updateImagen(item.id)" required />
                  <input type="url" class="form-control mr-1" placeholder="Url" :value="item.url"
                    :id="'url' + item.id" />
                  <button type="button" class="btn btn-warning btn-sm" @click="updateUrl(item)">
                    <i class="fa fa-floppy-o" aria-hidden="true"></i>
                  </button>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div class="d-flex align-items-center justify-content-center">
                  <p style="margin: 0;">
                    <b>Contador de visitas:</b> {{ item.count }}
                  </p>
                  <div @click="resetCount(item)" class="btn-reset-count" style="cursor: pointer;margin-left: 10px;">
                    <i aria-hidden="true" class="fa fa-trash-o"></i>
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td class="titulo">
                <div class="d-flex align-items-center justify-content-around">
                  <p v-if="item.slug"><strong>slug: </strong>{{ item.slug }}</p>
                  <div>
                    <p v-if="item.orden">
                      <strong>orden: </strong><input class="chico" type="text" :value="item.orden" :id="item.id">
                      <input type="button" class="ml-2 btn btn-primary" value="Guardar orden"
                        @click="updateOrden(item)">
                    </p>
                  </div>
                </div>
                <div class="d-flex align-items-center justify-content-around">
                  <div class="custom-control custom-switch" @click="updateVisible(item)">
                    <input type="checkbox" class="custom-control-input" :id="item.id" :checked="item.visible" />
                    <label class="custom-control-label" :class="{ opacity: item.visible == false }">Visible</label>
                  </div>
                  <div class="custom-control custom-switch mt-2" @click="updateAgotado(item)">
                    <input type="checkbox" class="custom-control-input" :id="item.id" :checked="item.agotado" />
                    <label class="custom-control-label" :class="{ opacity: item.agotado == false }">Agotado</label>
                  </div>
                  <div class="custom-control custom-switch mt-2" @click="updateDestacado(item)">
                    <input type="checkbox" class="custom-control-input" :id="item.id" :checked="item.destacado" />
                    <label class="custom-control-label" :class="{ opacity: item.destacado == false }">Destacado</label>
                  </div>
                </div>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import menuAdmin from "../components/MenuAdmin";
import Modal from "../components/Modal.vue";
import fire from "./../fire";
import Swal from 'sweetalert2';
export default {
  name: "AdminProductos",
  components: { menuAdmin, Modal },
  data() {
    return {
      productos: [],
      nombre: "",
      imagen: "",
      url: "",
      slug: "",
      orden: "",
      archivo: "",
      error: false,
      loading: false,
      addOfferModal: false
    };
  },
  methods: {
    chooseFiles(id) {
      document.getElementById(id).click()
    },
    onSubmit() {
      this.loading = true;
      this.imageUpload();
      this.toggleModal();
    },
    saveItem() {
      const producto = {
        nombre: this.nombre,
        url: this.url,
        slug: this.slug,
        imagen: this.imagen,
        orden: parseInt(this.orden),
        visible: false,
        count: 0
      };
      fire
        .database()
        .ref("productos")
        .push(producto);
      this.nombre = "";
      this.url = "";
      this.slug = "";
      this.imagen = "";
      this.orden = "";
      this.loading = false;
    },
    updateVisible(item) {
      let ver = null;
      console.log(item);
      if (item.visible == true) {
        ver = false;
      } else {
        ver = true;
      }
      fire
        .database()
        .ref("productos/" + item.id)
        .update(
          {
            visible: ver
          },
          function (error) {
            if (error) {
              console.log("error al guardar");
            } else {
              console.log("guardado");
            }
          }
        );
    },
    updateAgotado(item) {
      let ver = null;
      console.log(item);
      if (item.agotado == true) {
        ver = false;
      } else {
        ver = true;
      }
      fire
        .database()
        .ref("productos/" + item.id)
        .update(
          {
            agotado: ver
          },
          function (error) {
            if (error) {
              console.log("error al guardar");
            } else {
              console.log("guardado");
            }
          }
        );
    },
    updateDestacado(item) {
      let ver = null;
      console.log(item);
      if (item.destacado == true) {
        ver = false;
      } else {
        ver = true;
      }
      fire
        .database()
        .ref("productos/" + item.id)
        .update(
          {
            destacado: ver
          },
          function (error) {
            if (error) {
              console.log("error al guardar");
            } else {
              console.log("guardado");
            }
          }
        );
    },
    updateOrden(item) {
      let numero = document.getElementById(item.id).value;
      console.log('numero', numero)
      fire
        .database()
        .ref("productos/" + item.id)
        .update(
          {
            orden: numero
          },
          function (error) {
            if (error) {
              console.log("error al guardar");
            } else {
              console.log("guardado");
              alert('Guardado')
            }
          }
        );
    },
    updateUrl(item) {
      let url = document.getElementById('url' + item.id).value;
      console.log('url', url)
      fire
        .database()
        .ref("productos/" + item.id)
        .update(
          {
            url: url
          },
          function (error) {
            if (error) {
              console.log("error al guardar");
            } else {
              console.log("guardado");
              alert('Guardado')
            }
          }
        );
    },
    resetCount(item) {
      fire
        .database()
        .ref("productos/" + item.id)
        .update(
          {
            count: 0
          },
          function (error) {
            if (error) {
              console.log("error al guardar");
            } else {
              console.log("guardado");
            }
          }
        );
    },
    elimina(id) {
      console.log(id);
      let producto = fire
        .database()
        .ref("productos")
        .child(id);
      let respuesta = confirm("Deseas eliminar esta oferta?");
      if (respuesta == true) {
        producto.remove();
      }
    },
    imageUpload() {
      const ref = fire.storage().ref();
      const file = document.querySelector("#archivo").files[0];
      const name = +new Date() + "-" + file.name;
      const metadata = {
        contentType: file.type
      };
      const task = ref.child(name).put(file, metadata);
      task
        .then(snapshot => snapshot.ref.getDownloadURL())
        .then(url => {
          this.imagen = url;
          this.saveItem();
        })
        .catch(console.error);
    },
    updateImagen(id) {
      const ref = fire.storage().ref();
      const file = document.querySelector("#" + id + "_foto").files[0];
      if (file) {
        const name = +new Date() + "-" + file.name;
        const metadata = {
          contentType: file.type
        };
        const task = ref.child(name).put(file, metadata);
        task
          .then(snapshot => snapshot.ref.getDownloadURL())
          .then(url => {
            console.log(url);
            fire
              .database()
              .ref("productos/" + id)
              .update(
                {
                  imagen: url
                },
                function (error) {
                  if (error) {
                    console.log("error al guardar");
                  } else {
                    console.log("guardado");
                  }
                }
              );
          })
          .catch(console.error);
      } else {
        alert('debes subir un archivo')
      }

    },
    toggleModal() {
      this.addOfferModal ? (this.addOfferModal = false) : (this.addOfferModal = true);
    }
  },
  mounted() {
    let viewMessage = this;
    const itemsRef = fire.database().ref("productos");
    itemsRef.on("value", snapshot => {
      let data = snapshot.val();
      let productos = [];
      Object.keys(data).forEach(key => {
        productos.push({
          id: key,
          count: data[key].count,
          nombre: data[key].nombre,
          url: data[key].url,
          slug: data[key].slug,
          visible: data[key].visible,
          agotado: data[key].agotado,
          destacado: data[key].destacado,
          imagen: data[key].imagen,
          orden: data[key].orden
        });
      });
      viewMessage.productos = productos.sort((a, b) =>
        a.orden > b.orden ? -1 : Number(a.orden < b.orden)
      );
    });
  }
};
</script>

<style lang="scss">
img {
  &.imagen {
    width: 100px;
    height: auto;
  }
}

table td {
  vertical-align: middle;
}

.titulo {
  font-size: 1.1em;
}

input {
  &.chico {
    width: 50px;
  }
}

.btn-danger {
  position: absolute;
  top: 0;
  right: 15px;
  z-index: 2;
}
</style>